import { UserRole } from '../types/models';

/**
 * Converts a list of UserRole values to a formatted string with proper casing
 * and sorts them by hierarchy: Admin > Approver > Reviewer > C/M PIC > Issuer
 */
export const getRoleNames = (roles: UserRole[]): string => {
  if (!roles || roles.length === 0) return 'None';
  
  // Define role hierarchy for sorting
  const roleHierarchy = {
    [UserRole.ADMIN]: 1,
    [UserRole.APPROVER]: 2,
    [UserRole.REVIEWER]: 3,
    [UserRole.CM_PIC]: 4,
    [UserRole.ISSUER]: 5
  };
  
  // Sort roles by hierarchy
  const sortedRoles = [...roles].sort((a, b) => {
    const rankA = roleHierarchy[a] || 999; // Default high value for unknown roles
    const rankB = roleHierarchy[b] || 999;
    return rankA - rankB;
  });
  
  // Map roles to their display names
  return sortedRoles.map(role => {
    switch (role) {
      case UserRole.ADMIN:
        return 'Admin';
      case UserRole.APPROVER:
        return 'Approver';
      case UserRole.REVIEWER:
        return 'Reviewer';
      case UserRole.CM_PIC:
        return 'C/M PIC';
      case UserRole.ISSUER:
        return 'Issuer';
      default:
        // Convert to camel case for any other roles
        return String(role)
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
    }
  }).join(', ');
};
